"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mjmlToMjml = exports.mjmlToText = void 0;

var _htmlToText = _interopRequireDefault(require("html-to-text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mjmlToMjml = function mjmlToMjml(item, blockRenderer, isTopLevelNode) {
  return item.properties.content;
};

exports.mjmlToMjml = mjmlToMjml;

var mjmlToText = function mjmlToText(item, blockRenderer, isTopLevelNode) {
  var text = _htmlToText.default.fromString(item.properties.content || '', {
    wordwrap: 130,
    ignoreImage: true,
    preserveNewlines: true,
    format: {
      text: function text(elem) {
        return "".concat(elem.data, " ");
      }
    }
  }).trim().replace(/&nbsp;/g, ' ');

  return text + '\r\n';
};

exports.mjmlToText = mjmlToText;